module.exports = __webpack_public_path__ + "static/media/29EUNOG16.90db4767.jpg";